import React, { useEffect, useState } from "react";
import {
    Card,
    Grid,
    Typography,
    Button,
    Divider,
    Box,
    TableHead,
    Table,
    TableCell,
    TableBody,
    TableRow,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
    Stack
} from "@mui/material";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import Utils from "../../core/Utils";
import { useDispatch } from "react-redux";
import Loader from "../common/Loader";
import SideBarMenuItems from "../SideBarMenuItems";
import { SideBarMenuNames } from "../../core/Constants";
import { Container } from "@mui/system";
import { OrderDetailsPage, OrderSummaryPage, PurchaseOrderPage } from "../../core/PageConstants";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { connectToStore } from "../../data/store";
import UserHelper from "../../core/UserHelper";
import { getCountry } from "../../data/localSettingsActions";
import { postAsync } from "../../core/serviceClient";
import UpdateInventoryModal from "../dialogs/UpdateInventoryModal";

const OrderSummary = () => {
    document.title = "Order Summary";
    var pageTitle = "Order Summary";
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [msgOpen, setMsgOpen] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isNavigateToLogin, setIsNavigateToLogin] = useState(false);
    const [localSettings, setLocalSettings] = useState({});
    const [comment, setComment] = useState("");
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [selectedOrderId, setSelectedOrderId] = useState("");
    const [selectedOrder, setSelectedOrder] = useState("");
    const [selectedEditOrder, setSelectedEditOrder] = useState(null);
    const [dialogTitleName, setDialogTitleName] = useState("");

    const [invModalOpen, setInvModalOpen] = useState(false);

    useEffect(() => {
        let localSetting = connectToStore();
        if (UserHelper.CheckPermission(OrderSummaryPage, navigate)) {
            setLocalSettings(localSetting);
            if (!Utils.IsNullOrEmpty(location.state)) {
                var order = location.state.order
                setSelectedOrder(order);
            }
        }
    }, [selectedEditOrder]);

    const handleUpdateInventory = async (order) => {
        const ord = order
        setSelectedEditOrder(ord);
        setInvModalOpen(true);
    };

    const handleClosedOrder = async (order) => {
        const ord = order
        setSelectedOrderId(order.id);
        setDialogTitleName("Order Closed");
        handleOpenDialog();
    };

    const UpdateInventory = async (id, serviceItems) => {
        setIsLoading(true);
        let response = null;
        response = await postAsync("Shipment/UpdateInventory", {
            BusinessId: localSettings.business.businessId,
            OrderId: id,
            ServiceItems: serviceItems
        });
        setIsNavigateToLogin(response.isNavigateToLogin);
        if (response.error) {
            setMsgOpen(true);
            setMsgText(response.errorMessage);
        } else {
            setMsgText("Update Inventory Successfully");
            setMsgOpen(true);
            backNavigation();
        }
        setIsLoading(false);

    }

    const handleCancelOrder = async () => {
        setIsLoading(true);
        var response = await postAsync("Shipment/Reject", {
            OrderId: selectedOrderId,
            Comment: comment
        });
        setIsNavigateToLogin(response.isNavigateToLogin);
        if (response.error) {
            setMsgOpen(true);
            setMsgText(response.errorMessage);
        } else {
            setMsgText("Cancelled sucessfully");
            setMsgOpen(true);
            setIsDialogOpen(false);
        }
        setIsLoading(false);
        backNavigation();
    }

    const handleEditOrder = (order) => {
        navigate(PurchaseOrderPage.Path, {
            state: {
                selectedOrder: order,
                isFromOrderDetailsPage: true
            }
        });
    }
    const handleOpenDialog = () => setIsDialogOpen(true);
    const handleCloseDialog = () => setIsDialogOpen(false);


    const backNavigation = () => {
        navigate(OrderDetailsPage.Path, {});
    };

    const getShippedQuantity = (productId) => {
        return selectedOrder.receivedShipments
            ?.filter(s => s.productId === productId && s.isAddedToOnHand)
            .reduce((sum, s) => sum + (s.quantity || 0), 0) || 0;
    };

    function getVendorFullAddress(vendor) {
        if (!vendor) return '';

        if (Utils.IsNullOrEmpty(vendor.vendorAddress)) {
            const parts = [
                vendor.vendorCustomAddress,
                vendor.vendorCustomCity,
                vendor.vendorCustomState,
                vendor.vendorCustomPinCode
            ].filter(Boolean);

            return parts.join(', ');
        }

        return vendor.vendorAddress;
    }


    const ClosedOrder = async () => {
        setIsLoading(true);
        var response = await postAsync("Shipment/ClosedShippedOrder", {
            OrderId: selectedOrderId,
            Comment: comment
        });
        setIsNavigateToLogin(response.isNavigateToLogin);
        if (response.error) {
            setMsgOpen(true);
            setMsgText(response.errorMessage);
        } else {
            setMsgText("Closed the order sucessfully");
            setMsgOpen(true);
            setIsDialogOpen(false);
        }
        setIsLoading(false);
        backNavigation();
    }

    return (
        <Container maxWidth="false" className="bg-color p-0">
            <Grid className="container">
                <Loader open={isLoading} />
                <Dialog open={isDialogOpen} onClose={handleCloseDialog} className="font-size-14">
                    <DialogTitle
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        {dialogTitleName}
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant="h6" gutterBottom>
                            Comments
                        </Typography>

                        <TextField
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            label="Comments"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            placeholder="Enter Comments"
                            multiline
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            autoFocus
                            className="btn btn-primary white-text"
                            variant="contained"
                            color="primary"
                            disabled={!comment}
                            onClick={dialogTitleName === "Reject" ? handleCancelOrder : ClosedOrder}
                        >
                            Submit
                        </Button>
                        <Button
                            autoFocus
                            className="btn btn-secondary"
                            variant="contained"
                            style={{ backgroundColor: "gray" }}
                            onClick={handleCloseDialog}
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>

                <UpdateInventoryModal
                    open={invModalOpen}
                    onClose={(saved, editedItems) => {
                        setInvModalOpen(false);

                        if (saved && editedItems) {
                            UpdateInventory(selectedEditOrder.id, editedItems);
                        }
                    }}
                    order={selectedEditOrder}
                />
                <Box>
                    <Grid container m={0}>
                        <SideBarMenuItems selectedTab={SideBarMenuNames.Overview} />
                        <Grid xs={12} className="content-sec" sx={{ "padding-bottom": "100px" }}>
                            <Grid container direction="row" className="">
                                <Grid container className="title-sec">
                                    <Grid xs={12} md={8} lg={8}>
                                        <Typography
                                            level="h2"
                                            component="h2"
                                            fontWeight="600"
                                            fontSize="2rem"
                                        >
                                            <Button onClick={backNavigation} className="back-btn">
                                                <NavigateBeforeIcon />
                                            </Button>
                                            Order Summary
                                        </Typography>
                                    </Grid>
                                </Grid>
                                {!Utils.IsNullOrEmptyArray(selectedOrder) && (
                                    <Card
                                        variant="outlined"
                                        sx={{
                                            mb: 4,
                                            p: 3,
                                            boxShadow: 3,
                                            borderRadius: 3,
                                            backgroundColor: "#fafafa",
                                        }}
                                        style={{ width: "100%" }}
                                        alignItems="stretch"
                                        className="font-size-14 card white-bg"
                                    >
                                        <Grid container spacing={2} alignItems="center">
                                            <Grid item xs={6}>
                                                <Typography variant="h6" gutterBottom color="primary">🧾 Vendor Information</Typography>
                                                <Typography><strong>Name:</strong> {selectedOrder.vendorDetails.vendorName}</Typography>
                                                <Typography><strong>Contact:</strong> {selectedOrder.vendorDetails.vendorContact}</Typography>
                                                <Typography><strong>Address:</strong> {getVendorFullAddress(selectedOrder.vendorDetails)}</Typography>
                                            </Grid>

                                            <Grid item xs={6}>
                                                <Typography variant="h6" gutterBottom color="primary">📦 Order Details</Typography>
                                                <Typography><strong>ID:</strong> {selectedOrder.id}</Typography>
                                                <Typography><strong>Create Date:</strong> {moment(selectedOrder.createdDT).format('L LT')}</Typography>
                                                <Typography><strong>Status:</strong> {selectedOrder.status}</Typography>
                                                {selectedOrder.status === "Rejected" && (
                                                    <Typography><strong>Comments:</strong> {selectedOrder.comments}</Typography>
                                                )}
                                            </Grid>
                                        </Grid>

                                        <Divider sx={{ my: 2 }} />

                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell><strong>Product</strong></TableCell>
                                                    <TableCell className="text-end"><strong>Price</strong></TableCell>
                                                    <TableCell><strong>Tax</strong></TableCell>
                                                    <TableCell><strong>Ordered Qty</strong></TableCell>
                                                    <TableCell><strong>Shipped Qty</strong></TableCell>
                                                    <TableCell className="text-end"><strong>Total</strong></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {selectedOrder.serviceItems.map((item, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>{item.description}</TableCell>
                                                        <TableCell className="text-end">{Utils.GetCurrency(item.price.toFixed(2), localSettings.country)}</TableCell>
                                                        <TableCell>{item.taxPercent}%</TableCell>
                                                        <TableCell>{item.quantity}</TableCell>
                                                        <TableCell>{getShippedQuantity(item.productId)}</TableCell>
                                                        <TableCell className="text-end">{Utils.GetCurrency(item.totalPrice.toFixed(2), localSettings.country)}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>

                                        {/* <Grid item xs={6} marginTop={2}>
                                            <Typography variant="body1" fontWeight={500}>
                                                📝 <strong>Description:</strong> {selectedOrder.orderDesc}
                                            </Typography>
                                        </Grid> */}

                                        <Grid container justifyContent="space-between" alignItems="center" mt={3}>
                                            {selectedOrder.status !== "Received" && (
                                                <Grid item xs={12} md={8}>
                                                    <Stack direction="row">
                                                        {selectedOrder.status !== "Rejected" && (
                                                            <>
                                                                <Button
                                                                    variant="contained"
                                                                    className="btn btn-primary"
                                                                    sx={{ mr: 1 }}
                                                                    onClick={() => handleUpdateInventory(selectedOrder)}
                                                                >
                                                                    Update Inventory
                                                                </Button>
                                                                {selectedOrder.status !== "Requested" && (
                                                                    <Button
                                                                        variant="contained"
                                                                        className="btn btn-primary"
                                                                        sx={{ mr: 1 }}
                                                                        onClick={() => handleClosedOrder(selectedOrder)}
                                                                    >
                                                                        Closed the order
                                                                    </Button>)}
                                                            </>
                                                        )}
                                                        {selectedOrder.status !== "PartiallyShipped" && (
                                                            <>
                                                                <Button
                                                                    variant="contained"
                                                                    color="error"
                                                                    className="btn btn-primary"
                                                                    sx={{ mr: 1 }}
                                                                    onClick={() => handleEditOrder(selectedOrder)}
                                                                >
                                                                    Edit Order
                                                                </Button>

                                                                <Button
                                                                    variant="contained"
                                                                    color="error"
                                                                    className="btn btn-primary"
                                                                    onClick={() => {
                                                                        setSelectedOrderId(selectedOrder.id);
                                                                        setDialogTitleName("Reject");
                                                                        handleOpenDialog();
                                                                    }}
                                                                >
                                                                    Reject
                                                                </Button>
                                                            </>
                                                        )}
                                                    </Stack>
                                                </Grid>
                                            )}
                                            <Grid item xs={12} md={4}>
                                                <Stack justifyContent="end" className="text-end">
                                                    <Typography variant="h6" color="success.main">💰 Grand Total: {Utils.GetCurrency(selectedOrder.totalPrice.toFixed(2), localSettings.country)}</Typography>
                                                </Stack>
                                            </Grid>
                                        </Grid>

                                    </Card>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
        </Container>
    );
};

export default OrderSummary;
